module.exports = __webpack_public_path__ + "img/MHU_1.4ae7ee88.png";